// extracted by mini-css-extract-plugin
export default {"root":"_4sVcA","text-block":"AQvTg","textBlock":"AQvTg","prefix":"_1zR_t"};